// extracted by mini-css-extract-plugin
export default {"requirements":"Requirements_requirements__LKIl0"};